import whatsappLink from "./whatsappLink";
const visit = () => {
  return whatsappLink(
    "03201422222",
    "Hi there i am intrested in your listing",
    window.location.href
  );
};

export default visit